import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable()
export class AppConfigService {
  private appConfig;

  constructor(private http: HttpClient) { }

  loadAppConfig() {
    return this.http.get('./assets/config/app-config.json').map((response: env) => {
      return response;
    })
      .toPromise()
      .then(data => {
        this.appConfig = data;
        environment.AppName = data.AppName;
        environment.baseUrl = data.baseUrl;
        environment.DisplayName = data.DisplayName;
        environment.LogoUrl = data.LogoUrl;
        environment.NgSelectLimit = data.NgSelectLimit;
        environment.production = data.production;
        environment.reportUrl = data.reportUrl;
        environment.UserUrl = data.UserUrl;
        environment.DirectBarcodePrint = data.DirectBarcodePrint
        environment.noofdecimal = this.appConfig.noofdecimal;
        environment.MutipleSellingPriceEditable = data.MutipleSellingPriceEditable
        environment.IsRestaurant = data.IsRestaurant
        environment.ReportBasedOnPrivilege = data.ReportBasedOnPrivilege
        environment.SSRSReportUrl = data.SSRSReportUrl
        environment.ShowCostPriceOnItemSearch = data.ShowCostPriceOnItemSearch
        environment.ContactMandatoryonBOSale = data.ContactMandatoryonBOSale
        environment.SalemanMandatoryonBOSale = data.SalemanMandatoryonBOSale
        environment.RestMutipleSellingPriceEditable = data.RestMutipleSellingPriceEditable
        environment.InclusiveVATOnHTMLReports = data.InclusiveVATOnHTMLReports
        environment.ShowDashBoard = data.ShowDashBoard
        environment.RecipieDigits = data.RecipieDigits
        environment.EnableMultipleTax = data.EnableMultipleTax
        environment.MultipleIngredientSelection = data.MultipleIngredientSelection
        environment.DisableFieldsOnUpdate = data.DisableFieldsOnUpdate
        environment.ShowItemsBasedOnRoom = data.ShowItemsBasedOnRoom
        environment.DashBoardOnly = data.DashBoardOnly
        environment.TaxCaption = data.TaxCaption
        if (data.Azure != undefined || data.Azure != null) {
          environment.Azure.ClientId = data.Azure.ClientId
          environment.Azure.TenantId = data.Azure.TenantId
          environment.Azure.RedirectBaseUrl = data.Azure.RedirectBaseUrl
        }
        environment.ShowRestItemLongDescription=data.ShowRestItemLongDescription;
        this.loadAppMenu();
        this.loadAppReport();
      });
  }
  loadAppMenu() {
    return this.http.get('./assets/config/app_menu.json').map((respose: any) => {
      return respose;
    }).toPromise().then(data => {
      // console.log(data)
      environment.menuList = data;
    })
  }
  loadAppReport() {
    return this.http.get('./assets/config/app_reports.json').map((respose: any) => {
      return respose;
    }).toPromise().then(data => {
      // console.log(data)
      environment.ReportList = data;
    })
  }

  getConfig(): env {
    return this.appConfig;
  }
}

export interface env {
  production: boolean,
  AppName: string,
  NgSelectLimit: number,
  baseUrl: string,
  DisplayName: string,
  UserUrl: string,
  LogoUrl: string,
  reportUrl: string,
  DirectBarcodePrint: boolean,
  MutipleSellingPriceEditable: boolean
  IsRestaurant: boolean,
  SSRSReportUrl: string,
  ReportBasedOnPrivilege: boolean
  ShowCostPriceOnItemSearch: boolean
  ContactMandatoryonBOSale: boolean,
  SalemanMandatoryonBOSale: boolean
  RestMutipleSellingPriceEditable: boolean
  InclusiveVATOnHTMLReports: boolean
  ShowDashBoard: boolean
  RecipieDigits: number
  EnableMultipleTax: boolean
  MultipleIngredientSelection: false
  DisableFieldsOnUpdate: false
  ShowItemsBasedOnRoom: false
  DashBoardOnly: false
  TaxCaption: string
  Azure: {
    ClientId: string,
    TenantId: string,
    RedirectBaseUrl: string
  }
  ShowRestItemLongDescription:boolean
}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/services/app-config.service.ts